<script>
  import { Navbar, Link, NavRight } from "framework7-svelte";

  export let title = "";
  export let subtitle = undefined;
  export let panelId = "#panel-left";
</script>

<Navbar {title} {subtitle}>
  <svelte:fragment slot="left">
    {#if panelId}
      <Link
        iconIos="f7:menu"
        iconAurora="f7:menu"
        iconMd="material:menu"
        panelOpen={panelId}
        title="Open Navigation Menu"
      />
    {/if}
    <slot name="left" />
  </svelte:fragment>

  {#if $$slots.right || $$slots.default}
    <NavRight slot="right">
      <slot name="right" />
      <slot />
    </NavRight>
  {/if}
</Navbar>
